import DOCUMENT_CONFIGS from './documentsVerificationConstants';

export default [
    {
        events: [DOCUMENT_CONFIGS.EXCEPTIONAL_CIRCUMSTANCES_OR_PLAN_PROGRAM_ERROR],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.DOC_INDICATING_EXCEPTIONS,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.SPECIAL_CIRCUMSTANCE_ATTESTATION],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.UNSUPPORTED_EVENT],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.DOC_PROVING_EVENT,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.DOC_SUPPORTING_EVENT],
            },
        ],
    },
];
